
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ai-twin-generator",
      function () {
        return require("private-next-pages/ai-twin-generator/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ai-twin-generator"])
      });
    }
  